<template>
    <color-picker v-model="valueNew" class="amColor">
        <figure class="amColor__content">
            <figcaption class="amColor__text">
                {{ valueNew }}
            </figcaption>

            <div class="amColor__preview" :style="{ backgroundColor: valueNew }" />
        </figure>
    </color-picker>
</template>

<script>
export default {
    name: 'tween-input-color',

    props: {
        value: {
            type: String,
            default: '#000000',
        },
    },

    data() {
        return {
            valueNew: '',
        };
    },

    watch: {
        valueNew() {
            this.$emit('input', this.valueNew);
        },
    },

    created() {
        this.valueNew = this.value;
    },
};
</script>

<style lang="scss">
.amColor {
    font-weight: 600;
    font-size: 0.875rem;
    border: 1px solid var(--app-borderColor);
    padding: 0.125em 0.5em 0.125em;
    width: $tween-input-width;

    &:hover {
        cursor: pointer;
    }

    &__content {
        display: flex;
        align-items: center;
    }

    &__preview {
        width: 1em;
        height: 1em;
    }

    &__text {
        margin-right: 0.5em;
    }
}
</style>
